import qs from 'qs'
import { createItemsData } from '../utils/request.utils'
import { QueueService } from './base-service'
import { HALApiService } from './hal-api.service'

export const pickingQueueService = new QueueService('/storage/tasks/queue', HALApiService, createItemsData, qs)
